/** UUID v1–v5 pattern (used as course id by the API). */
const COURSE_UUID_RE =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

/**
 * Build an SEO-friendly slug from an Arabic/English course name.
 * Keeps Arabic letters and alphanumerics; turns spaces/punctuation into `-`.
 */
export function slugifyCourseName(name?: string | null): string {
  const slug = (name || '')
    .trim()
    .replace(/[\s_]+/g, '-')
    .replace(/[^\u0600-\u06FFa-zA-Z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  return slug || 'course';
}

/**
 * Public course URL: `/courses/{course-name-slug}-{uuid}`
 * Old UUID-only URLs still resolve via `resolveCourseIdFromParam`.
 */
export function getCoursePath(course: {
  id: string;
  courseName?: string | null;
}): string {
  const slug = slugifyCourseName(course.courseName);
  return `/courses/${slug}-${course.id}`;
}

/** Extract course UUID from a route param (slug-uuid or bare uuid). */
export function resolveCourseIdFromParam(
  param?: string | null
): string | null {
  if (!param) return null;
  const decoded = decodeURIComponent(param);
  const match = decoded.match(
    new RegExp(
      `(${COURSE_UUID_RE.source})$`,
      'i'
    )
  );
  return match?.[1] ?? null;
}

export function isCourseUuid(value?: string | null): boolean {
  if (!value) return false;
  return new RegExp(`^${COURSE_UUID_RE.source}$`, 'i').test(value);
}
